module.exports = __webpack_public_path__ + "static/media/Table1_Before.11efac2c.jpg";